import type { CommentBody } from '@liveblocks/client'
import type { ComposerSubmitComment } from '@liveblocks/react-ui/primitives'

import { CommentComposer } from '@/components/lemmala-design-system/comment-composer/comment-composer'
import { COMMENT_COMPOSER_LABELS } from '@/components/lemmala-design-system/comment-composer/labels'

import { EDITOR_COMPONENTS } from './consts'
import { CommentAudienceProvider } from './context'

type CommentEditComposerProps = {
  defaultValue: CommentBody
  onSave: (comment: ComposerSubmitComment) => void | Promise<void>
  onCancel: () => void
}

export const CommentEditComposer = ({
  defaultValue,
  onSave,
  onCancel,
}: CommentEditComposerProps) => (
  <CommentAudienceProvider value='internal'>
    <CommentComposer
      submitLabel={COMMENT_COMPOSER_LABELS.save}
      actionsAppearance='compact'
      editorComponents={EDITOR_COMPONENTS}
      defaultValue={defaultValue}
      onSubmit={onSave}
      onCancel={onCancel}
    />
  </CommentAudienceProvider>
)
